<span class="close-icon" [mat-dialog-close]="true" style="cursor: pointer">
    <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M7.2626 21.9621L6.0376 20.7371L12.7751 13.9996L6.0376 7.26211L7.2626 6.03711L14.0001 12.7746L20.7376 6.03711L21.9626 7.26211L15.2251 13.9996L21.9626 20.7371L20.7376 21.9621L14.0001 15.2246L7.2626 21.9621Z" fill="#ACACAC"/>
    </svg>
</span>
<div class="box-remove-admin">
    <div class="header">
        <h2 class="font-bold d-flex justify-content-center">{{ 'AreYouSurePopup.Title'| translate}}</h2>
    </div>
    <button class="btn-yes font-bold btn-common-style" (click)="clickRemove()">{{ 'AreYouSurePopup.BtnYes'| translate }}</button>
    <button mat-button class="btn-no font-bold" [mat-dialog-close]="true">{{ 'AreYouSurePopup.BtnNo'| translate }}</button>
</div>
